export async function signOut() {
  if (!isAuth0Enabled()) {
    return
  }

  auth0WordpressPlugin.signOut()
}

export async function getSignedUserInfo() {
  if (!isAuth0Enabled()) {
    return null
  }

  const user = await auth0WordpressPlugin.getAuthenticatedUser()

  if (user) {
    return user
  }

  return null
}

export function isAuth0Enabled() {
  return (
    typeof auth0WordpressPlugin !== 'undefined' &&
    auth0WordpressPlugin?.isEnabled
  )
}

export function isAuth0LoginEnabled() {
  return (
    typeof auth0WordpressPlugin !== 'undefined' &&
    auth0WordpressPlugin?.isEnabledAuth0Login
  )
}
